import dateUtils from "@/utils/date";

export const listeDeCoursesOverviewProps = () => ({
  liste: {
    type: Object,
    required: true
  }
})

export const useListeDeCoursesOverview = (props) => {
  const dateLastUsageFormatted = computed(() => {
    if (props.liste.attributes.date_last_usage && props.liste.attributes.date_last_usage !== props.liste.attributes.date_creation) {
      return "Modifiée le " + dateUtils.formatDate(props.liste.attributes.date_last_usage);
    } else {
      return "Créée le " + dateUtils.formatDate(props.liste.attributes.date_creation);
    }
  })
  const countProduits = computed(() => {
    return props.liste.attributes.nb_produits_manquant ? props.liste.attributes.nb_produits + props.liste.attributes.nb_produits_manquant : props.liste.attributes.nb_produits
  })

  return {
    dateLastUsageFormatted,
    countProduits
  }
}